<template>
  <div>
    <b-form-rating
        v-model="currentField.rateValue"
        :name="`formData[${currentField.tagname}]`"
        :show-clear="currentField.showClear === true"
        :show-value="currentField.showScore === true"
        :disabled="currentField.disabled"
        :required="this.currentField.isRequired"
        :class="{'is-invalid' : error}"
        ></b-form-rating>
        <span class="invalid-feedback" role="alert" v-if="error">
                  <strong>{{ error }}</strong>
              </span>
  </div>
</template>


<script>
export default {
  name: 'Rating',
  props: ['currentField', 'error'],
  data() {
    return {
      value: null
    }
  },
  mounted() {
    // console.log('currentField', this.currentField)
  }
}
</script>

<style>
.el-rate {
  padding-top: 12px;
}
</style>
